import { createContext} from 'react';

// Create a context for managing wrapper classes
export const WrapperContext = createContext<{
  wrapperClasses: string;
  setWrapperClasses: (classes: string) => void;
}>({
  wrapperClasses: '',
  setWrapperClasses: () => {},
});

